import { render } from "./UserRoadmap.vue?vue&type=template&id=65c94bfa"
import script from "./UserRoadmap.vue?vue&type=script&lang=ts"
export * from "./UserRoadmap.vue?vue&type=script&lang=ts"
script.render = render

export default script